<template>
  <div
    class="comp-container comp-container__announce POS-f TRBL-0"
  >
    <div class="H-100 row no-gutters justify-content-center">
      <div class="H-100 col col-md-6 col-lg-4">
        <div class="wrapper H-100">
          <div class="push" />
          <transition
            name="animation-modal"
          >
            <div
              class="modal PR-m PL-m POS-r BDRS-m BGC-white"
              v-scroll-lock="true"
              v-if="show"
            >
              <div class="header POS-s PT-m PB-m BGC-white TA-c">
                <div class="header__left"></div>
                <div class="header__title FW-b">{{ $t('announce') }}</div>
                <div class="header__right">
                  <button v-on:click="close()">
                    <span class="material-icons-round">close</span>
                  </button>
                </div>
              </div>
              <div class="main">
                <vue-markdown
                  :source="announce"
                  :anchor-attributes="{ target: '_blank', rel: 'nofollow' }"
                />
              </div>
            </div>
          </transition>
          <div class="push" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import VScrollLock from 'v-scroll-lock';

Vue.use(VScrollLock);

export default {
  props: ['title', 'announce'],
  components: {
    VueMarkdown,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.show = true;
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="sass" scoped>
.comp-container__announce
  width: 100%
  z-index: $z-index-modal
  overflow: auto

  background-color: rgba(0, 0, 0, .25)

  &::-webkit-scrollbar
    display: none

.wrapper
  display: flex
  flex-direction: column

.push
  height: 10vh
  flex-grow: 1

.modal
  bottom: 0
  width: 100%
  overflow: auto

  -webkit-overflow-scrolling: touch
  box-shadow: 0 1px 4px rgba(0, 0, 0, .25)

.header
  top: 0
  z-index: $z-index-sticky
  display: flex
  align-items: center

  background: linear-gradient(180deg, white 75%, rgba(255, 255, 255, 0) 100%)

  &__left,
  &__title,
  &__right
    height: 32px

  &__left,
  &__right
    width: 32px

  &__title
    flex-grow: 1
    line-height: 32px

  button
    @extend .P-xxs
    @extend .W-xl
    @extend .H-xl

    border: none
    @extend .BDRS-100

    @extend .BGC-t

    @extend .C-grey

    appearance: none
    outline: 0

    &:active
      @extend .BGC-light

      outline: 0

.main
  ::v-deep a
    color: currentcolor
    text-decoration: underline

  ::v-deep img
    max-width: 100%

  ::v-deep p
    margin-top: 1rem
</style>
